import { useQuery, useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, MutationConfig, QueryConfig } from '@/lib/react-query';

import { AppointmentResponse, Event } from '../types';
import { Blob } from 'buffer';
export type GetEventRequestDTO = {
  businessId?: number;
  startDate?: Date;
  endDate?: Date;
  page: number;
  perPage: number;
  tabSelected: number;
  groupedBy?: string;
  search?: string;
  id?: string;
  sort?: string;
  order?: string;
  isRoomBookings?: boolean;
  type?: string;
  selectedServiceProviderId?: string;
};

export const getEventsCSVData = (
  { tabSelected, startDate, endDate, page, perPage, isRoomBookings }: GetEventRequestDTO = {
    page: 1,
    perPage: 10,
    tabSelected: 0,
    isRoomBookings: false,
  }
): Promise<any> => {
  return axios.get(`/business/calendar/appointments?csv=true`, {
    params: { start: startDate, end: endDate, page, perPage },
  });
};
export const getEvents = (
  {
    tabSelected,
    startDate,
    endDate,
    page,
    perPage,
    groupedBy,
    search,
    sort,
    id,
    order,
    isRoomBookings,
    selectedServiceProviderId,
  }: GetEventRequestDTO = {
    page: 1,
    perPage: 10,
    tabSelected: 0,
    isRoomBookings: false,
  }
): Promise<AppointmentResponse> => {
  //console.log("asdasd", tabSelected)
  const url = isRoomBookings ? `rooms/bookings/all` : `/business/calendar/appointments`;
  if (isRoomBookings) {
    return axios.get(
      tabSelected == 1
        ? `${url}?accepted=true`
        : tabSelected == 2
        ? `${url}?checkin=true`
        : tabSelected == 3
        ? `${url}?completed=true`
        : tabSelected == 4
        ? `${url}?cancelled=true`
        : `${url}?requested=true`,
      {
        params: {
          start: startDate,
          end: endDate,
          page,
          perPage,
          groupedBy,
          search,
          sort,
          id,
          order,
          userId: selectedServiceProviderId,
        },
      }
    );
  } else {
    return axios.get(
      tabSelected == 1
        ? `${url}?accepted=true`
        : tabSelected == 2
        ? `${url}?completed=true`
        : tabSelected == 3
        ? `${url}?cancelled=true`
        : `${url}?requested=true`,
      {
        params: {
          start: startDate,
          end: endDate,
          page,
          perPage,
          groupedBy,
          search,
          sort,
          id,
          order,
          userId: selectedServiceProviderId,
        },
      }
    );
  }
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof getEvents>;
};

type UseUpdateBusinessOptionsCSV = {
  config?: MutationConfig<typeof getEventsCSVData>;
};

export const useEvent = ({ config }: UseUpdateBusinessOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getEvents,
  });
};

export const useEventsCSV = ({ config }: UseUpdateBusinessOptionsCSV = {}) => {
  return useMutation({
    ...config,
    mutationFn: getEventsCSVData,
  });
};

export const getClientEventsCSVData = (
  {
    tabSelected,
    startDate,
    endDate,
    page,
    perPage,
    groupedBy,
    search,
    sort,
    order,
    isRoomBookings,
    type,
  }: GetEventRequestDTO = {
    page: 1,
    perPage: 10,
    tabSelected: 0,
    isRoomBookings: false,
  }
): Promise<Blob> => {
  const url = `/business/calendar/clients/appointments-csv?csv=true`;
  return axios.get(`${url}`, {
    params: {
      start: startDate,
      end: endDate,
      page,
      perPage,
      groupedBy,
      search,
      sort,
      order,
      type,
    },
    responseType: 'blob',
  });
};

type UseUpdateBusinessOptionsCSVs = {
  config?: MutationConfig<typeof getClientEventsCSVData>;
};

export const useClientEventsCSV = ({ config }: UseUpdateBusinessOptionsCSVs = {}) => {
  return useMutation({
    ...config,
    mutationFn: getClientEventsCSVData,
  });
};
